import { createSignal } from '@verclam/pulsar';

/**
 * Location key of the navigation on which the drawer was opened, or `null`. A location key is unique per
 * navigation, even towards the current URL: any navigation outdates the value, so the drawer closes
 * without a synchronisation effect.
 */
const navigationDrawerSignal = createSignal<string | null>(null);

export const openNavigationDrawerAt = (locationKey: string): void => {
	navigationDrawerSignal.value = locationKey;
};

export const closeNavigationDrawer = (): void => {
	navigationDrawerSignal.value = null;
};

export default navigationDrawerSignal;
